<template>
    <section class="heroSection -green">
        <div class="heroSection__static">
            <div class="productHero__top">
                <div class="uk-container">
                    <div class="productHero__titleSection">
                        <h1 class="heroSection__title">
                            {{$root.source.page.post_title}} 
                        </h1>
                    </div>
                </div>
            </div>
            <div class="heroSection__bottom">
                <div class="heroSection__sliderPattern -desktop">
                    <div class="uk-container">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1340 12" width="1340" height="12">
                          <rect width="1340" height="12" fill="#0B0B0B"/>
                          <rect width="36.638" height="12" fill="#FFFF54"/>
                          <rect x="40.638" width="24.425" height="12" fill="#FFFF54"/>
                          <rect x="69.063" width="9.16" height="12" fill="#81FBA5"/>
                          <rect x="82.222" width="12.213" height="12" fill="#81FBA5"/>
                          <rect x="98.435" width="9.159" height="12" fill="#71ECBC"/>
                          <rect x="111.594" width="12.213" height="12" fill="#44BFFC"/>
                          <rect x="127.807" width="12.212" height="12" fill="#5C41FF"/>
                          <rect x="144.02" width="12.212" height="12" fill="#746AFC"/>
                          <rect x="160.231" width="12.212" height="12" fill="#8080F0"/>
                          <rect x="176.444" width="12.213" height="12" fill="#A6B0FF"/>
                          <rect x="192.657" width="12.213" height="12" fill="#A6B0FF"/>
                          <rect x="208.87" width="12.212" height="12" fill="#E4E4E4"/>
                          <rect x="225.083" width="12.212" height="12" fill="#E4E4E4"/>
                          <rect x="241.294" width="12.212" height="12" fill="#A3A2A2"/>
                          <rect x="257.507" width="12.212" height="12" fill="#A3A2A2"/>
                          <rect x="273.72" width="12.212" height="12" fill="#A3A2A2"/>
                          <rect x="289.932" width="21.372" height="12" fill="#6C6A6B"/>
                          <rect x="315.304" width="24.425" height="12" fill="#6C6A6B"/>
                          <rect x="343.729" width="24.426" height="12" fill="#A6B0FF"/>
                          <rect x="372.154" width="36.638" height="12" fill="#8AC2D5"/>
                          <rect x="412.792" width="45.797" height="12" fill="#8AC2D5"/>
                          <rect x="462.589" width="65.456" height="12" fill="#86DAC0"/>
                          <rect x="532.128" width="144.281" height="12" fill="#86DAC0"/>
                          <rect x="680.607" width="343.068" height="12" fill="#81FBA5"/>
                          <rect x="1027.879" width="312.121" height="12" fill="#81FBA5"/>
                      </svg>
                    </div>
                </div>
                <div class="heroSection__sliderPattern -mobile">
                    <div class="uk-container">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 390 10" width="390" height="10">
                          <rect width="390" height="10" fill="#0B0B0B"/>
                          <rect y="-1" width="36.638" height="12" fill="#FFFF54"/>
                          <rect x="40.638" y="-1" width="24.425" height="12" fill="#FFFF54"/>
                          <rect x="69.063" y="-1" width="9.16" height="12" fill="#81FBA5"/>
                          <rect x="82.222" y="-1" width="12.213" height="12" fill="#81FBA5"/>
                          <rect x="98.435" y="-1" width="9.159" height="12" fill="#71ECBC"/>
                          <rect x="111.594" y="-1" width="12.213" height="12" fill="#44BFFC"/>
                          <rect x="127.807" y="-1" width="12.212" height="12" fill="#5C41FF"/>
                          <rect x="144.02" y="-1" width="12.213" height="12" fill="#746AFC"/>
                          <rect x="160.231" y="-1" width="12.212" height="12" fill="#8080F0"/>
                          <rect x="176.444" y="-1" width="12.212" height="12" fill="#8080F0"/>
                          <rect x="192.657" y="-1" width="12.213" height="12" fill="#A6B0FF"/>
                          <rect x="208.87" y="-1" width="12.213" height="12" fill="#A6B0FF"/>
                          <rect x="225.082" y="-1" width="12.213" height="12" fill="#A6B0FF"/>
                          <rect x="241.294" y="-1" width="12.213" height="12" fill="#E4E4E4"/>
                          <rect x="257.508" y="-1" width="12.213" height="12" fill="#E4E4E4"/>
                          <rect x="273.721" y="-1" width="12.212" height="12" fill="#A3A2A2"/>
                          <rect x="289.934" y="-1" width="12.212" height="12" fill="#A3A2A2"/>
                          <rect x="306.146" y="-1" width="12.212" height="12" fill="#A3A2A2"/>
                          <rect x="322.357" y="-1" width="21.372" height="12" fill="#6C6A6B"/>
                          <rect x="347.729" y="-1" width="24.425" height="12" fill="#6C6A6B"/>
                          <rect x="376.155" y="-1" width="24.426" height="12" fill="#A6B0FF"/>
                      </svg>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  export default {
    name: 'IndexTop',
    props: [],
    computed: {},
    methods: {},
    created: function() {},
    mounted: function () {},
    beforeDestroy: function () {}
  };
</script>
